import { FlagsSetter } from '../setters';
import ExperimentsRepository from './ExperimentsRepository';

export class RoxFlagRepository {
  map
  constructor() {
    this.map = {};
  }

  addFlag(name, flag) {
    flag.name = name;
    this.map[name] = flag;
    new FlagsSetter(this, ExperimentsRepository).setAddedFlag(flag);
  }

  flagWithName(name) {
    return this.map[name];
  }

  get flags() {
    return Object.keys(this.map).map(t => this.map[t]);
  }

  get items() {
    return this.flags;
  }
}

export default new RoxFlagRepository();
